import usePostPaymentOrderCardToCardTransaction from '../../../../services/hookService/postPaymentOrderCardToCardTransaction/usePostPaymentStoreOrderCardToCardTransaction';
import usePostPaymentStoreOrderCardToCardTransaction from '../../../../services/hookService/postPaymentStoreOrderCardToCardTransaction/usePostPaymentStoreOrderCardToCardTransaction';

import {
  PaymentMethodValues,
  paymentTypeMap,
  TransactionTypesChoices,
} from '../utils/helpers';

export function useCreateCardToCardTransaction({
  transactionType,
  paymentType,
  orderGuid,
  storeOrderGuid,
  image,
  enabled = true,
  handleAfterSuccess,
}: {
  transactionType?: TransactionTypesChoices;
  paymentType?: PaymentMethodValues;
  orderGuid?: string;
  storeOrderGuid?: string;
  image: File | null;
  enabled?: boolean;
  handleAfterSuccess?: (data: unknown) => void;
}) {
  const orderMutation =
    usePostPaymentOrderCardToCardTransaction(handleAfterSuccess);

  const storeOrderMutation =
    usePostPaymentStoreOrderCardToCardTransaction(handleAfterSuccess);

  const emptyMutation = {
    mutate: (_: any) => {},
    isLoading: false,
    isSuccess: false,
  };

  let activeMutation = emptyMutation;

  switch (transactionType) {
    case TransactionTypesChoices.ORDER:
      activeMutation = orderMutation;
      break;

    case TransactionTypesChoices.STORE_ORDER:
      activeMutation = storeOrderMutation;
      break;

    default:
      activeMutation = emptyMutation;
  }

  const mutate = () => {
    if (!enabled || !paymentType || !image) {
      return;
    }

    const mappedPaymentType = paymentTypeMap[paymentType];

    if (transactionType === TransactionTypesChoices.ORDER && orderGuid) {
      activeMutation.mutate({
        order: orderGuid,
        image,
        payment_type: mappedPaymentType,
      });
    }

    if (
      transactionType === TransactionTypesChoices.STORE_ORDER &&
      storeOrderGuid
    ) {
      activeMutation.mutate({
        store_order: storeOrderGuid,
        image,
        payment_type: mappedPaymentType,
      });
    }
  };

  return {
    mutate,
    isLoading: activeMutation.isLoading,
    isSuccess: activeMutation.isSuccess,
  };
}
